
import { Component, Vue, Prop} from 'vue-property-decorator';

import PageBase from "../PageBase.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import _ from 'underscore';
const applicationState = namespace("Application");

@Component({
    components:{
        PageBase
    }
})
export default class ExpensesFs extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;  
    tableKey = 0;
    housingTableKey = 0;
    foodTableKey = 0;
    transportTableKey = 0;
    clothingTableKey = 0;
    healthTableKey = 0;
    childrenTableKey = 0;
    miscellaneousTableKey = 0;
    premiumsTableKey = 0;
    taxTableKey = 0;
    otherTableKey = 0;

    otherDesc = "";

    expenseFields = [
        {key:"amountName",      label:"Expenses",       tdClass:"border-left-0 align-middle",   thClass:"text-primary border-left-0",   thStyle:"font-size:12pt; width:60%;"}, 
        {key:"monthlyAmount",   label:"Monthly Total",  tdClass:"border-top-0 align-middle",    thClass:"text-primary",                 thStyle:"font-size:12pt; width:18%;"},
        {key:"yearlyAmount",    label:"Yearly Total",   tdClass:"border-top-0 align-middle",    thClass:"text-primary",                 thStyle:"font-size:12pt; width:19%;"}  
    ];
    
    housingItem = [
        {amountName:"Rent/mortgage",                    monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Property taxes and strata fees",   monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Utilities",                        monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Homeowner/renter’s insurance",     monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Home maintenance and repair",      monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Other",                            monthlyAmount: 0,   yearlyAmount: 0}
    ];

    foodItem = [
        {amountName:"Groceries",            monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Eating out",           monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Household supplies",   monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Other",                monthlyAmount: 0,   yearlyAmount: 0}
    ];

    transportItem = [
        {amountName:"Car insurance and car loan payments",  monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Fuel",                                 monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Maintenance and repairs",              monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Public transit, taxis and parking",    monthlyAmount: 0,   yearlyAmount: 0},
        {amountName:"Other",                                monthlyAmount: 0,   yearlyAmount: 0}
    ];

    clothingItem = [
        {amountName: "include clothing, hair dresser/barber and cosmetics",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    healthItem = [
        {amountName: "include regular dental care, orthodontics, medicine, eye glasses or contact lenses",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    childrenItem = [
        {amountName: "include school activities, extracurricular activities, tuition/school fees, camps, babysitting, allowances and daycare",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    miscellaneousItem = [
        {amountName: "include gifts & donations, alcohol, tobacco & cannabis, entertainment & recreation, cell phone, cable, subscription services, pet expenses and vacations",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    premiumsItem = [
        {amountName: "include life or term insurance premiums, RRSP or other contributions, debt repayment (for expenses not itemized above)",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    taxItem = [
        {amountName: "amount of income tax you pay",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    otherItem = [
        {amountName: "Specify:",  monthlyAmount: 0,   yearlyAmount: 0}
    ];
    
    totalExpensesItem = [
        {amountName: "Total",  monthlyAmount: 0,   yearlyAmount: 0}
    ];

    mounted(){        
        this.reloadPageInformation();
    } 
    
    public reloadPageInformation() {        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        if (this.step.result?.expensesFSSurvey?.data) {
            const expenseData = this.step.result.expensesFSSurvey.data
            if (expenseData.housing){
                this.housingItem = expenseData.housing;
            }
            if(expenseData.food){
                this.foodItem = expenseData.food;
            }
            if(expenseData.transport){
                this.transportItem = expenseData.transport;
            }
            if(expenseData.clothing){
                this.clothingItem = expenseData.clothing;
            }
            
            if(expenseData.health){
                this.healthItem = expenseData.health;
            }

            if(expenseData.children){
                this.childrenItem = expenseData.children;
            }

            if(expenseData.miscellaneous){
                this.miscellaneousItem = expenseData.miscellaneous;
            }

            if(expenseData.premiums){
                this.premiumsItem = expenseData.premiums;
            }

            if(expenseData.tax){
                this.taxItem = expenseData.tax;
            }

            if(expenseData.other){
                this.otherItem = expenseData.other;
            }

            if(expenseData.total){
                this.totalExpensesItem = expenseData.total;
            }

            this.otherDesc = expenseData.otherDesc?expenseData.otherDesc:''; 
            
            Vue.filter('scrollToLocation')(this.$store.state.Application.scrollToLocationName);            
        }      

        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 50, false);
    }
    
    public inputValueChanged(tableName, amountType, data){

        if(tableName == 'housing'){
            if(amountType)
                this.housingItem[data.index].monthlyAmount = this.housingItem[data.index].yearlyAmount/12;
            else
                this.housingItem[data.index].yearlyAmount = 12 * this.housingItem[data.index].monthlyAmount;        
            this.housingTableKey++
        
        } else if(tableName == 'food'){
            if(amountType)
                this.foodItem[data.index].monthlyAmount = this.foodItem[data.index].yearlyAmount/12;
            else
                this.foodItem[data.index].yearlyAmount = 12 * this.foodItem[data.index].monthlyAmount;        
            this.foodTableKey++
        
        } else if(tableName == 'transport'){
            if(amountType)
                this.transportItem[data.index].monthlyAmount = this.transportItem[data.index].yearlyAmount/12;
            else
                this.transportItem[data.index].yearlyAmount = 12 * this.transportItem[data.index].monthlyAmount;        
            this.transportTableKey++
        
        } else if(tableName == 'clothing'){
            if(amountType)
                this.clothingItem[data.index].monthlyAmount = this.clothingItem[data.index].yearlyAmount/12;
            else
                this.clothingItem[data.index].yearlyAmount = 12 * this.clothingItem[data.index].monthlyAmount;        
            this.clothingTableKey++
        
        } else if(tableName == 'health'){
            if(amountType)
                this.healthItem[data.index].monthlyAmount = this.healthItem[data.index].yearlyAmount/12;
            else
                this.healthItem[data.index].yearlyAmount = 12 * this.healthItem[data.index].monthlyAmount;        
            this.healthTableKey++
        
        } else if(tableName == 'children'){
            if(amountType)
                this.childrenItem[data.index].monthlyAmount = this.childrenItem[data.index].yearlyAmount/12;
            else
                this.childrenItem[data.index].yearlyAmount = 12 * this.childrenItem[data.index].monthlyAmount;        
            this.childrenTableKey++
        
        } else if(tableName == 'miscellaneous'){
            if(amountType)
                this.miscellaneousItem[data.index].monthlyAmount = this.miscellaneousItem[data.index].yearlyAmount/12;
            else
                this.miscellaneousItem[data.index].yearlyAmount = 12 * this.miscellaneousItem[data.index].monthlyAmount;        
            this.miscellaneousTableKey++
        
        } else if(tableName == 'premiums'){
            if(amountType)
                this.premiumsItem[data.index].monthlyAmount = this.premiumsItem[data.index].yearlyAmount/12;
            else
                this.premiumsItem[data.index].yearlyAmount = 12 * this.premiumsItem[data.index].monthlyAmount;        
            this.premiumsTableKey++
        
        } else if(tableName == 'tax'){
            if(amountType)
                this.taxItem[data.index].monthlyAmount = this.taxItem[data.index].yearlyAmount/12;
            else
                this.taxItem[data.index].yearlyAmount = 12 * this.taxItem[data.index].monthlyAmount;        
            this.taxTableKey++
        
        } else if(tableName == 'other'){
            if(amountType)
                this.otherItem[data.index].monthlyAmount = this.otherItem[data.index].yearlyAmount/12;
            else
                this.otherItem[data.index].yearlyAmount = 12 * this.otherItem[data.index].monthlyAmount;        
            this.otherTableKey++
        
        }

        const totalMonthlyHousing = this.housingItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyHousing = this.housingItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyFood = this.foodItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyFood = this.foodItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyTransport = this.transportItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyTransport = this.transportItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyClothing = this.clothingItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyClothing = this.clothingItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyHealth = this.healthItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyHealth = this.healthItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyChildren = this.childrenItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyChildren = this.childrenItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyMiscellaneous = this.miscellaneousItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyMiscellaneous = this.miscellaneousItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyPremiums = this.premiumsItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyPremiums = this.premiumsItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyTax = this.taxItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyTax = this.taxItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);

        const totalMonthlyOther = this.otherItem.reduce((sum, amount) => sum + Number(amount.monthlyAmount), 0);
        const totalYearlyOther = this.otherItem.reduce((sum, amount) => sum + Number(amount.yearlyAmount), 0);
       
        this.totalExpensesItem[0].monthlyAmount = totalMonthlyHousing + totalMonthlyFood + totalMonthlyTransport
                                                    + totalMonthlyClothing + totalMonthlyHealth + totalMonthlyChildren
                                                    + totalMonthlyMiscellaneous + totalMonthlyPremiums + totalMonthlyTax
                                                    + totalMonthlyOther;
        this.totalExpensesItem[0].yearlyAmount = totalYearlyHousing + totalYearlyFood + totalYearlyTransport
                                                    + totalYearlyClothing + totalYearlyHealth + totalYearlyChildren
                                                    + totalYearlyMiscellaneous + totalYearlyPremiums + totalYearlyTax
                                                    + totalYearlyOther;
        this.tableKey ++;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage()
    }

    public getExpenseResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        if(this.getExpenseInfo()){

            const incomeInfo = this.getExpenseInfo();
            for(const incomeType of incomeInfo.total) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.housing) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Housing - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.food) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Food - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.transport) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Transport - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.clothing) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Clothing - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.health) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Health - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.children) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Children - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.miscellaneous) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Miscellaneous - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.premiums) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Premiums - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.tax) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Tax - ' + Vue.filter('beautify-amount-name')(incomeType.amountName) +' yearly amount:', inputType:''})
            }

            for(const incomeType of incomeInfo.other) {
                questionResults.push({name:'expensesFSSurvey', value: '$ '+ incomeType.yearlyAmount, title: 'Other - ' + incomeInfo.otherDesc +' yearly amount:', inputType:''})
            }

        }  
        
        return {data: this.getExpenseInfo(), questions:questionResults, pageName:'Expenses', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getExpenseInfo(){       

        let result = {
            housing: this.housingItem, 
            food: this.foodItem,
            transport: this.transportItem,
            clothing: this.clothingItem,
            health: this.healthItem,
            children: this.childrenItem,
            miscellaneous: this.miscellaneousItem,
            premiums: this.premiumsItem,
            tax: this.taxItem,
            other: this.otherItem,
            total: this.totalExpensesItem,
            otherDesc: this.otherDesc
        }

        return result;
    }
    
    beforeDestroy() {        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, true);        
        this.UpdateStepResultData({step:this.step, data: {expensesFSSurvey: this.getExpenseResults()}})
    }
}
